/** Escape text for interpolation into an HTML string (email bodies). */
export const escapeHtml = (value: string): string =>
  value.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");

/** Escape text for interpolation into a double-quoted HTML attribute. */
export const escapeAttr = (value: string): string =>
  escapeHtml(value).replace(/"/g, "&quot;");
